module.exports = __webpack_public_path__ + "static/media/voucherWhite.edd415fd.png";